const ReturnsIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M4 12h16M12 4v16'
      stroke='currentColor'
      strokeWidth='1.6'
      strokeLinecap='round'
    />
  </svg>
);

export default ReturnsIcon;
